import { ProductCard } from 'components/Cards';
import React from 'react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

import styles from './styles/slider.module.scss';
const Slider = ({ products }) => {

  if(products === undefined || products.length === 0 ) return null;
  
  return (
    <>
      <Swiper
        modules={[Pagination]}
        spaceBetween={0}
        slidesPerView={4}
        pagination={{
          clickable: true,
          horizontalClass: styles.pagination,
          bulletActiveClass: styles.pagination__bullet_active,
          bulletClass: styles.pagination__bullet,
          lockClass: styles.pagination__bullet_lock,
        }}
        breakpoints={{
          320: {
            slidesPerView: 1
          },
          700: {
            slidesPerView: 2
          },
          1025:{
            slidesPerView: 3
          },
          1700: {
            slidesPerView: 4
          }
        }}
        className={styles.slider}>
        {products.map((el) => (
          <SwiperSlide className={styles.slider__item} key={el.id}>
            <ProductCard product={el} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default Slider;
